import axios from 'axios';
import { backendUrl, API_KEYS } from '../config';

const api = axios.create({
  baseURL: backendUrl,
});

// Ajout d'un interceptor pour injecter les headers API KEY/SECRET sur chaque requête
api.interceptors.request.use(config => {
  config.headers = config.headers || {};
  config.headers['x-api-key'] = API_KEYS.key;
  config.headers['x-api-secret'] = API_KEYS.secret;
  return config;
});

// EventEmitter simple pour signaler un 401
class ApiEventEmitter {
  constructor() {
    this.listeners = [];
  }
  on(fn) { this.listeners.push(fn); }
  off(fn) { this.listeners = this.listeners.filter(l => l !== fn); }
  emit(event) { this.listeners.forEach(fn => fn(event)); }
}
export const apiEvents = new ApiEventEmitter();

// Intercepteur de réponse pour gérer le 401 globalement
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.localStorage.removeItem('token');
      window.sessionStorage.removeItem('token');
      apiEvents.emit('session_expired');
    }
    return Promise.reject(error);
  }
);

export default api;
